import { print } from "graphql";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../hooks/useAPI";
import { useDispatch } from "react-redux";
import { UPDATE_ACTIVE_PORTFOLIO } from "../../store/actions/portfolio.actions";
import { X_FETCH_LABELS } from "../../graphql/portfolio.gql-query";

interface Variables {
  id: number;
  currency: string;
}

export const useGetLabelsQuery = (variables: Variables) => {
  const field = "labels";
  const Api = useApi({});
  const dispatch = useDispatch();

  // Query will only run if the variables are defined
  const enabled = variables.id !== undefined && variables.currency !== undefined;

  return useQuery(
    ["X_FETCH_LABELS", variables],
    async () => {
      const payload = {
        operationName: "FetchLabelsForPortfolio",
        variables,
        query: print(X_FETCH_LABELS),
      };

      const response = await Api.post("", JSON.stringify(payload));
      const portfolio = response?.data?.data?.portfolio;

      if (field && portfolio) {
        return portfolio[field];
      }

      return portfolio || [];
    },
    {
      enabled, // Query will be enabled when variables are defined
      onError: (error) => {
        console.error("fail: useGetLabelsQuery", error);
      },
      onSuccess: (data) => {
        dispatch({ type: UPDATE_ACTIVE_PORTFOLIO, payload: data });
      },
      placeholderData: [],
      staleTime: 1000 * 60 * 60, // 1 hour
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    }
  );
};
